import type { RouteSupport, SidebarDef } from '@cobliteam/dashboard/src/dashboardDef';

export const getRouteSupport = (sidebar: SidebarDef): RouteSupport | undefined => {
  const { route, secondary } = sidebar;

  if (route?.support) return route.support;

  if (!(route && secondary)) return undefined;

  return secondary.find((parentRoute) => parentRoute.tabs?.some((tab) => tab.id === route.id))?.support;
};
